import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface ProductSubCategoryPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;

  categoryId: number;
  categoryName: string;

  onRegister: (data: {
    categoryId: number;
    name: string;
  }) => void;
}

const ProductSubCategoryPopup: React.FC<
  ProductSubCategoryPopupProps
> = ({
  popupOpen,
  setPopupOpen,
  categoryId,
  categoryName,
  onRegister,
}) => {

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(
        2,
        'El nombre debe tener al menos 2 caracteres'
      )
      .required(
        'El nombre de la subcategoría es obligatorio'
      ),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
    },

    validationSchema,

    onSubmit: (values, { resetForm }) => {

      onRegister({
        categoryId,
        name: values.name,
      });

      resetForm();

      setPopupOpen(false);
    },
  });

  useEffect(() => {

    if (!popupOpen) {
      formik.resetForm();
    }

  }, [popupOpen]);

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Agregar Subcategoría"
      maxWidth="max-w-md"
    >
      <form
        onSubmit={formik.handleSubmit}
        className="mt-4"
      >

        <div className="mb-5">

          <label className="mb-2 block text-sm font-medium text-black dark:text-white">
            Categoría
          </label>

          <div className="rounded border border-stroke bg-gray-2 px-4 py-3 dark:border-strokedark dark:bg-meta-4">
            <span className="text-black dark:text-white">
              {categoryName}
            </span>
          </div>

        </div>

        <InputField
          label="Nombre"
          name="name"
          type="text"
          placeholder="Ingrese nombre de la subcategoría"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name &&
            formik.errors.name
              ? formik.errors.name
              : undefined
          }
          iconKey="edit"
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
          disabled={!categoryId}
        >
          Guardar Subcategoría
        </button>

      </form>
    </FormModal>
  );
};

export default ProductSubCategoryPopup;